"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Content = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var React = _interopRequireWildcard(require("react"));
var _InfoSlide = require("../InfoSlide");
var _ArticlesSlide = require("../ArticlesSlide");
const _excluded = ["type"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Content = props => {
  const {
      type
    } = props,
    restProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  if (type === 'info') {
    return /*#__PURE__*/React.createElement(_InfoSlide.InfoSlide, restProps);
  }
  if (type === 'articles') {
    return /*#__PURE__*/React.createElement(_ArticlesSlide.ArticlesSlide, restProps);
  }
  return null;
};
exports.Content = Content;